import React, { FC } from 'react';
import { SelectProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { AgentApplicationStatus } from '~/types/AgentApplication';
import Select from './Select';

const status: Record<string, AgentApplicationStatus> = {
  fillingData: 'fillingData',
  onReview: 'onReview',
  services: 'services',
  contract: 'contract',
  payment: 'payment',
  terminated: 'terminated',
  automatedOnboarding: 'automatedOnboarding',
  failedOnboarding: 'failedOnboarding',
  manualOnboarding: 'manualOnboarding',
  completed: 'completed',
  rejected: 'rejected',
  // duplicate: 'duplicate',
  // draft: 'draft',
  // screeningFailed: 'screeningFailed',
  // approval: 'approval',
  // onboarding: 'onboarding',
  // posPreparation: 'posPreparation',
  // posInstallation: 'posInstallation',
  // hardRejected: 'hardRejected',
  // screening: 'screening',
  // submissionFailure: 'submissionFailure',
};
// const statusss = AgentApplicationStatus[] = [

// ]

const ApplicationStatusSelect: FC<SelectProps<string>> = (props) => {
  const { t } = useTranslation('applicationStatus');
  const options = Object.values(status).map((value: any) => ({
    label: t(value),
    value,
    key: value,
  }));

  return <Select showSearch options={options} {...props} />;
};

export default ApplicationStatusSelect;
